export default {
    bgColor: 0x1d3bff,
    primaryKey: "BGElmnts_Crsbns",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setPosition(data.x, data.y);
        image.setScale(0);
        image.angle = 180;
        let deltaScale = 1 - (data.scaleX/1);

        bg.scene.addTween(image, 1000, {angle: data.angle, scaleX: data.scaleX, scaleY: data.scaleY, delay: deltaScale * 1000}, "Back");
    },
    animateOut: (image, bg)=>{
        let deltaScale = 1 - (image.scaleX/1);
        bg.scene.addTween(image, 500, {angle: 180, scaleX: 0, scaleY: 0, delay: deltaScale * 500}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Crsbns",
            x: 548.7818971929687, y: 390.1314031180401,
            angle: 30,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Crsbns",
            x: 152.22785107465842, y: 488.33853006681517,
            angle: 9,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Crsbns",
            x: 930.073092432369, y: 720.5144766146993,
            angle: 9,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Crsbns",
            x: 45.19172897989012, y: 266.97772828507794,
            angle: 20,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 816.6160200446307, y: 147.07349665924278,
            angle: 6,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 573.8733116705164, y: 50.182628062360806,
            angle: 23,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 425.9172114995629, y: 545.7706013363029,
            angle: 23,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 669.8046823004346, y: 644.1224944320713,
            angle: 6,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 823.5893460700257, y: 500.1804008908686,
            angle: 19,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 252.30398413133412, y: 164.6391982182628,
            angle: 4,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 104.63740881389553, y: 659.3853006681514,
            angle: 4,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 286.9344373540044, y: 343.6726057906459,
            angle: 28,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 301.604901538582, y: -8.763919821826281,
            angle: 9,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Crsbns",
            x: 971.8483080817967, y: 2.538975501113587,
            angle: 20,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Crsbns",
            x: 38.92887810098005, y: 81.07572383073497,
            angle: 4,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 816.0102963629957, y: 313.8574610244989,
            angle: 3,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 1029.3606728523146, y: 395.2761692650334,
            angle: 3,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 668.2389695807071, y: 809.9086859688197,
            angle: 3,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 1079.899711597437, y: 225.33407572383075,
            angle: 9,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Crsbns",
            x: 701.0141852301349, y: -101.08017817371937,
            angle: 31,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Crsbns",
            x: 464.40290229547566, y: 181.44097995545658,
            angle: -11,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnts_Crsbns",
            x: 315.8677524174921, y: 676.6213808463252,
            angle: -11,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnts_Crsbns",
            x: 628.5951793707344, y: 228.34743875278397,
            angle: 26,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Crsbns",
            x: 1064.610186743922, y: 573.15144766147,
            angle: 26,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Crsbns",
            x: 480.7705046392358, y: 724.6993318485523,
            angle: 28,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        }
    ]
}